module.exports = __webpack_public_path__ + "fonts/Inter-Medium.1aa99aa.ttf";